import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { History } from 'lucide-react';
export function OlderTurnsButton({ older }) {
    const label = older.loading
        ? 'Loading earlier turns…'
        : older.error
            ? 'Could not load earlier turns · Retry'
            : `Load ${older.turns} earlier ${older.turns === 1 ? 'turn' : 'turns'}`;
    return (_jsxs("button", { type: "button", className: "vk-older", "data-older-turns": older.turns, "aria-busy": older.loading || undefined, disabled: older.loading, onClick: older.onLoad, children: [_jsx(History, { size: 14, "aria-hidden": "true" }), " ", label] }));
}
//# sourceMappingURL=OlderTurns.js.map